import classnames from "classnames";
import PropTypes from "prop-types";

const Checkbox = ({
  label,
  subLabel,
  errors,
  touched,
  icon,
  required,
  ...rest
}) => {
  const inputId = `checkbox-${label.replace(/\s+/g, "-").toLowerCase()}`;
  const inputClass = classnames({
    "disable--input": rest.disabled,
  });

  return (
    <label className="mobilityMutual__checkbox" htmlFor={inputId}>
      <input id={inputId} type="checkbox" className={inputClass} {...rest} />
      <div className="mobilityMutual__checkbox--label">
        <div
          className="mobilityMutual__checkbox--label--text"
          dangerouslySetInnerHTML={{ __html: label }}
        ></div>
        {subLabel && (
          <div className="mobilityMutual__checkbox--label--subLabel">
            {subLabel}
          </div>
        )}
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
};

Checkbox.defaultProps = {
  label: "",
  subLabel: "",
};

export default Checkbox;
